import React from 'react';
import { Select } from '../../../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { Input } from '../../../../../../../../../../CommonComponents/OPL/Input/Input';

export const DisabledRow = () => {
  return (
    <>
      <tr>
        <td>
          <Select disabled />
        </td>
        <td>
          <Input disabled rightIcon="far fa-percent" />
        </td>
        <td />
      </tr>
    </>
  );
};
